<template>
  <div class="acceso">
    <form class="acceso__tarjeta" @submit.prevent="entrar">
      <header class="acceso__cabecera">
        <span class="acceso__marca"><i class="mdi mdi-radar"></i></span>
        <div>
          <h1>Comando</h1>
          <p>Entra con tu cuenta para abrir el tablero.</p>
        </div>
      </header>

      <label class="acceso__campo">
        <span>Usuario</span>
        <input
          ref="usuario"
          v-model.trim="usuario"
          type="text"
          name="username"
          autocomplete="username"
          autocapitalize="none"
          autocorrect="off"
          spellcheck="false"
          required
          :disabled="enviando"
        >
      </label>

      <label class="acceso__campo">
        <span>Clave</span>
        <div class="acceso__clave">
          <input
            v-model="clave"
            :type="verClave ? 'text' : 'password'"
            name="password"
            autocomplete="current-password"
            required
            :disabled="enviando"
          >
          <button
            class="acceso__ojo"
            type="button"
            :title="verClave ? 'Ocultar la clave' : 'Ver la clave'"
            :aria-label="verClave ? 'Ocultar la clave' : 'Ver la clave'"
            @click="verClave = !verClave"
          >
            <i class="mdi" :class="verClave ? 'mdi-eye-off' : 'mdi-eye'"></i>
          </button>
        </div>
      </label>

      <p v-if="error" class="acceso__error" role="alert">
        <i class="mdi mdi-alert-circle"></i> {{ error }}
      </p>

      <button class="acceso__boton" type="submit" :disabled="enviando || !completo">
        <i class="mdi" :class="enviando ? 'mdi-loading mdi-spin' : 'mdi-login'"></i>
        {{ enviando ? 'Entrando…' : 'Entrar' }}
      </button>

      <p class="acceso__pie">
        Las cuentas se crean desde el panel de administración.
      </p>
    </form>
  </div>
</template>

<script>
// Postea a /api/sesion/ y recarga hacia el destino que indique el backend: la
// sesión vive en la cookie, así que el mapa se pide de nuevo ya autenticado.
import { iniciarSesion } from '@/services/comandoApi';

export default {
  name: 'LoginForm',
  data() {
    return {
      usuario: '',
      clave: '',
      verClave: false,
      enviando: false,
      error: '',
    };
  },
  computed: {
    completo() {
      return this.usuario.length > 0 && this.clave.length > 0;
    },
    // De dónde venía el usuario cuando login_required lo mandó para acá.
    destino() {
      return new URLSearchParams(window.location.search).get('next') || '/';
    },
  },
  mounted() {
    if (this.$refs.usuario) this.$refs.usuario.focus();
  },
  methods: {
    async entrar() {
      if (this.enviando || !this.completo) return;
      this.enviando = true;
      this.error = '';

      try {
        const sesion = await iniciarSesion(this.usuario, this.clave, this.destino);
        window.location.assign(sesion.destino || '/');
      } catch (e) {
        this.error = this.motivo(e);
        this.clave = '';
        this.enviando = false;
      }
    },

    motivo(e) {
      const respuesta = e.response;
      if (!respuesta) return 'No se pudo hablar con el servidor. Revisa la conexión.';
      const detalle = respuesta.data && respuesta.data.detail;
      if (respuesta.status === 429) {
        return 'Demasiados intentos seguidos. Espera un momento y vuelve a probar.';
      }
      if (respuesta.status === 403 && !detalle) {
        // 403 sin cuerpo es el CSRF rechazado: la cookie ya no sirve.
        return 'La sesión del navegador caducó. Recarga la página y vuelve a intentar.';
      }
      return detalle || 'No se pudo iniciar sesión.';
    },
  },
};
</script>
